import React from 'react';
import styled from 'styled-components';
import { Tooltip } from 'antd';

import useTranslation from '@src/hooks/useTranslation';
import { SquareIcon, CheckedSquareIcon } from 'src/components/common/icon';

const tooltipStyle = {
	whiteSpace: 'nowrap',
} as React.CSSProperties;

const StyledCheckedSquareIcon = styled(CheckedSquareIcon)`
	& > path {
		fill: ${props => props.theme.colors.primary};
	}
`;

const ButtonGroup = styled.div`
	display: flex;
`;

const ActiveButton = styled.div`
	padding: 8px 50px;
	color: ${props => props.theme.colors.primary};
	border: 1px solid ${props => props.theme.colors.primary};
	border-radius: 4px 0px 0px 4px;
	background: #FFFFFF;
	text-align: center;

	@media ${props => props.theme.device.smTablet} {
		padding: 8px 0px;
		flex: 1 1 auto;
	}

	@media ${props => props.theme.device.mobile} {
		padding: 8px 0px;
		flex: 1 1 auto;
	}
`;

const DisableButton = styled.div`
	padding: 8px 50px;
	border-radius: 0px 4px 4px 0px;
	cursor: not-allowed;
	border: 1px solid #DDDDDD;
	border-left: 0px;
	font-weight: 300;
	background: #FFFFFF;
	text-align: center;

	@media ${props => props.theme.device.smTablet} {
		padding: 8px 0px;
		flex: 1 1 auto;
	}

	@media ${props => props.theme.device.mobile} {
		padding: 8px 0px;
		flex: 1 1 auto;
	}
`;

const CheckBoxWrapper = styled.div`
	cursor: pointer;
	& > *:not(:last-child) {
		margin-right: 8px;
	}
	display: flex;
	align-items: center;
	width: fit-content;

	@media ${props => props.theme.device.smTablet} {
		margin-top: 20px;
	}

	@media ${props => props.theme.device.mobile} {
		margin-top: 20px;
	}
`;

const Label = styled.label`
	cursor: pointer;
`;

const OperatorWrapper = styled.div`
	display: flex;
	justify-content: space-between;
	user-select: none;

	@media ${props => props.theme.device.smTablet} {
		margin-bottom: 20px;
		flex-direction: column;
	}

	@media ${props => props.theme.device.mobile} {
		margin-bottom: 20px;
		flex-direction: column;
	}
`;

interface IOperator {
	checked: boolean;
	isSignedIn: boolean;
	handleOnClick: () => void;
}

const Operator = ({ checked, isSignedIn, handleOnClick }: IOperator): JSX.Element => {
	const { t } = useTranslation();

	return (
		<OperatorWrapper>
			<ButtonGroup style={{ visibility: 'hidden' }}>
				<ActiveButton>{t('course:discussions:discussions_before')}</ActiveButton>
				{/**
				 * TODO:
				 * Tooltip will be removed after 'discussions' finished.
				*/}
				<Tooltip
					placement="topRight"
					title={t('all:discussion_coming_soon')}
					trigger="hover"
					color="rgba(0, 0, 0, 0.75)"
					overlayStyle={tooltipStyle}
				>
					<DisableButton>{t('course:discussions:discussions')}</DisableButton>
				</Tooltip>
			</ButtonGroup>
			{isSignedIn && (
				<CheckBoxWrapper
					onClick={handleOnClick}
				>
					{checked ? <StyledCheckedSquareIcon /> : <SquareIcon />}
					<Label>{t('course:discussions:only_my_message')}</Label>
				</CheckBoxWrapper>
			)}
		</OperatorWrapper>
	);
};

export default Operator;
